export const CLICK_ON_PRODUCT_CONDITION_TAG = (tagValue: string) => ({
  event: 'interaction_click on a block',
  e_category: 'navigation',
  e_action: 'Click on a block',
  event_trigger: 'grading tag',
  amp_event_name: 'Click on a block',
  e_label: 'grading tag',
  click_element: tagValue,
  page_type: 'productPage',
});
